export const API_ROUTE_AUTHENTICATE = 'dealer/authenticate'
export const API_ROUTE_PROFILE = 'dealer/profile'
export const API_ROUTE_MANAGER_TOKEN = 'dealer/manager-token/:customerId'

export const API_ROUTE_CUSTOMERS = 'dealer/customers'
export const API_ROUTE_CUSTOMER = `${API_ROUTE_CUSTOMERS}/:customer_id`
export const API_ROUTE_COST_OBJECTS = `${API_ROUTE_CUSTOMER}/cost-objects`
export const API_ROUTE_POLICIES = `${API_ROUTE_CUSTOMER}/policies`
export const API_ROUTE_FRAME_AGREEMENT = `${API_ROUTE_CUSTOMER}/frame-agreement`
export const API_ROUTE_FRAME_AGREEMENT_APPLICATION = `${API_ROUTE_CUSTOMER}/frame-agreement/application`

export const API_ROUTE_SHOP = 'dealer/shop'
export const API_ROUTE_SHOP_CUSTOMER = `${API_ROUTE_SHOP}/customer/:customer_id`
export const API_ROUTE_SHOP_INVENTORY = `${API_ROUTE_SHOP_CUSTOMER}/inventory`
export const API_ROUTE_SHOP_TEMP_ORDERS = `${API_ROUTE_SHOP}/quotes`
export const API_ROUTE_SHOP_TEMP_ORDER = `${API_ROUTE_SHOP_TEMP_ORDERS}/:order_id`
export const API_ROUTE_SHOP_TEMP_ORDER_CONFIRMATION = `${API_ROUTE_SHOP_TEMP_ORDERS}/:order_id/confirm`
export const API_ROUTE_SHOP_CREDIT_CHECK = `${API_ROUTE_SHOP_TEMP_ORDER}/credit-check`
export const API_ROUTE_SHOP_CREDIT_CHECK_DEMO = `${API_ROUTE_SHOP_TEMP_ORDER}/demo-credit-check`
export const API_ROUTE_SHOP_CREDIT_CHECK_PDF = `${API_ROUTE_SHOP_CREDIT_CHECK}/pdf`
export const API_ROUTE_SHOP_ORDERS = 'dealer/shop/orders'
export const API_ROUTE_SHOP_ORDER = `${API_ROUTE_SHOP_ORDERS}/:order_id`
export const API_ROUTE_SHOP_ORDER_STATUS = `${API_ROUTE_SHOP_ORDER}/status`
export const API_ROUTE_SHOP_ORDER_SMS = `${API_ROUTE_SHOP_ORDER}/sms-log`
export const API_ROUTE_SHOP_ORDER_IMEI = `${API_ROUTE_SHOP_ORDER}/product/:orderLineId`

export const API_ROUTE_DEVICE_POLICY_PRICES = 'dealer/device-policy/prices'
export const API_ROUTE_DEVICE_POLICY_PRICE = `${API_ROUTE_DEVICE_POLICY_PRICES}/:priceId`

export const API_ROUTE_SUBSCRIPTION_ORDERS = 'dealer/subscription-orders'
export const API_ROUTE_SUBSCRIPTION_ORDERS_META_DATA = 'dealer/subscription-orders/order-meta'

export const API_ROUTE_PORTING_SUBSCRIPTION_TOTAL_ORDERS =
  'dealer/subscription-orders/total/:order_type'
export const API_ROUTE_PORTING_SUBSCRIPTION_ORDERS = 'dealer/subscription-orders/onboarding'
export const API_ROUTE_TERMINATION_SUBSCRIPTION_ORDERS = 'dealer/subscription-orders/termination'
export const API_ROUTE_UPGRADE_SUBSCRIPTION_ORDERS = 'dealer/subscription-orders/upgrade'
export const API_ROUTE_SUBSCRIPTION_ORDER = `${API_ROUTE_SUBSCRIPTION_ORDERS}/:order_id`
export const API_ROUTE_SUBSCRIPTION_START = `${API_ROUTE_SUBSCRIPTION_ORDER}/start`
export const API_ROUTE_SUBSCRIPTION_COMPLETE = `${API_ROUTE_SUBSCRIPTION_ORDER}/complete`
export const API_ROUTE_SUBSCRIPTION_CANCEL = `${API_ROUTE_SUBSCRIPTION_ORDER}/cancel`
export const API_ROUTE_SUBSCRIPTION_TERMINATE = `${API_ROUTE_SUBSCRIPTION_ORDER}/terminate`
export const API_ROUTE_SUBSCRIPTION_SMS = `${API_ROUTE_SUBSCRIPTION_ORDER}/sms-log`
export const API_ROUTE_SUBSCRIPTION_REMAINDER_SMS = `${API_ROUTE_SUBSCRIPTION_ORDER}/remainder-sms`
export const API_ROUTE_SUBSCRIPTION_AUTHORIZATION_MAIL = `${API_ROUTE_SUBSCRIPTION_ORDER}/authorization-mail`

export const API_ROUTE_DEVICE_ORDERS = 'dealer/device-orders'
export const API_ROUTE_DEVICE_ORDER = `${API_ROUTE_DEVICE_ORDERS}/:order_id`
export const API_ROUTE_DEVICE_ORDER_CANCEL = `${API_ROUTE_DEVICE_ORDER}/cancel`
export const API_ROUTE_DEVICE_ORDER_COMPLETE = `${API_ROUTE_DEVICE_ORDER}/complete`
export const API_ROUTE_DEVICE_ORDER_DELIVER = `${API_ROUTE_DEVICE_ORDER}/deliver`
export const API_ROUTE_DEVICE_ORDER_SMS = `${API_ROUTE_DEVICE_ORDER}/sms-log`
export const API_ROUTE_DEVICE_ORDER_ECOM = `${API_ROUTE_DEVICE_ORDER}/ecom`

export const API_ROUTE_DOCUMENT = 'dealer/document'
export const API_ROUTE_DOCUMENT_HPE_CREDIT_CHECK = `${API_ROUTE_DOCUMENT}/hpe-credit-check`

export const API_ROUTE_DASHBOARD = 'dashboard'
export const API_ROUTE_STATS = `${API_ROUTE_DASHBOARD}/statistics`
export const API_ROUTE_NOTIFICATIONS = `${API_ROUTE_DASHBOARD}/notifications`

export const API_ROUTE_TRANSLATIONS = 'translations/dealer'
export const API_ROUTE_TRANSLATION = 'dealer/translation'

export const API_ROUTE_INJURY_REPORTS = 'dealer/injury-reports'
export const API_ROUTE_INJURY_REPORT = `${API_ROUTE_INJURY_REPORTS}/:id`
export const API_ROUTE_INJURY_REPORT_COMMENT = `${API_ROUTE_INJURY_REPORT}/comment`
export const API_ROUTE_INJURY_REPORT_STATUS = `${API_ROUTE_INJURY_REPORT}/status`
export const API_ROUTE_INJURY_REPORT_SMS = 'injury-reports/:id/sms'

export const API_ROUTE_BECHTLE = 'dealer/bechtle'
export const API_ROUTE_CREDIT_REQUEST_QUOTES = `${API_ROUTE_BECHTLE}/credit-requests`
export const API_ROUTE_CREDIT_REQUEST_QUOTE_CUSTOMERS = `${API_ROUTE_CREDIT_REQUEST_QUOTES}/customers`
export const API_ROUTE_CREDIT_REQUEST_QUOTE_RESET = `${API_ROUTE_CREDIT_REQUEST_QUOTES}/:credit_request_id/reset`
export const API_PATH_CREDIT_REQUEST_QN_NN = `${API_ROUTE_CREDIT_REQUEST_QUOTES}/:creditRequestId`

export const API_ROUTE_SYSTEM_MESSAGES = 'dealer/system-messages'

export const API_ROUTE_TRADE_IN_ORDERS = 'tradein/orders'
export const API_ROUTE_TRADE_IN_ORDER = 'tradein/order/:orderId'

/**
 * New admin backend apis
 */
export const API_ROUTE_SHOP_ORDER_AUDIT_LOG = 'orders-change-trail/:orderId'
export const API_ROUTE_DATA_SEEDING = 'data-seeding/data-sets'
export const API_ROUTE_DATA_SEEDING_DEMO_TARGETS = 'data-seeding/demo-targets'

export const API_ROUTE_ORDERS_PRODUCTS = 'products'
export const API_ROUTE_ORDERS_RELATED_PRODUCTS = `${API_ROUTE_ORDERS_PRODUCTS}/:productId/related`
export const API_ROUTE_ORDERS_PRODUCTS_CATEGORY_CLASSIFICATION = `${API_ROUTE_ORDERS_PRODUCTS}/classifications`
